export const FORM_PROPERTY_DETAILS_SUBMIT =
  "appPropertyState/FORM_PROPERTY_DETAILS_SUBMIT";
